"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var actions_1 = require("@shopify/app-bridge/actions");

var context_1 = require("../../context");
/**
 * ResourcePicker component
 *
 * @remarks
 * React component which wraps the Shopify App Bridge ResourcePicker action.
 *
 * @public
 */


var ResourcePicker =
/** @class */
function (_super) {
  __extends(ResourcePicker, _super);

  function ResourcePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.focusReturnPoint = null;
    return _this;
  }

  ResourcePicker.prototype.componentDidMount = function () {
    var _a = this.props,
        open = _a.open,
        resourceType = _a.resourceType,
        onSelection = _a.onSelection,
        onCancel = _a.onCancel;
    var app = this.context;
    this.picker = actions_1.ResourcePicker.create(app, {
      resourceType: actions_1.ResourcePicker.ResourceType[resourceType],
      options: this.getActionOptions()
    });

    if (onSelection != null) {
      this.picker.subscribe(actions_1.ResourcePicker.Action.SELECT, onSelection);
    }

    if (onCancel != null) {
      this.picker.subscribe(actions_1.ResourcePicker.Action.CANCEL, onCancel);
    }

    if (open) {
      this.focusReturnPoint = document.activeElement;
      this.picker.dispatch(actions_1.ResourcePicker.Action.OPEN);
    }
  };

  ResourcePicker.prototype.componentDidUpdate = function (prevProps) {
    var wasOpen = prevProps.open;
    var _a = this.props,
        open = _a.open,
        onCancel = _a.onCancel,
        onSelection = _a.onSelection;
    this.picker.unsubscribe();
    this.picker.set(this.getActionOptions());

    if (onSelection != null) {
      this.picker.subscribe(actions_1.ResourcePicker.Action.SELECT, onSelection);
    }

    if (onCancel != null) {
      this.picker.subscribe(actions_1.ResourcePicker.Action.CANCEL, onCancel);
    }

    if (wasOpen !== open) {
      if (open) {
        this.picker.dispatch(actions_1.ResourcePicker.Action.OPEN);
      } else {
        this.picker.dispatch(actions_1.ResourcePicker.Action.CLOSE);
      }
    }

    if (!wasOpen && open) {
      this.focusReturnPoint = document.activeElement;
    } else if (wasOpen && !open && this.focusReturnPoint != null && document.contains(this.focusReturnPoint)) {
      this.focusReturnPoint.focus();
      this.focusReturnPoint = null;
    }
  };

  ResourcePicker.prototype.componentWillUnmount = function () {
    this.picker.unsubscribe();
  };

  ResourcePicker.prototype.render = function () {
    return null;
  };

  ResourcePicker.prototype.getActionOptions = function () {
    var _a = this.props,
        initialQuery = _a.initialQuery,
        initialSelectionIds = _a.initialSelectionIds,
        showHidden = _a.showHidden,
        allowMultiple = _a.allowMultiple,
        selectMultiple = _a.selectMultiple,
        actionVerb = _a.actionVerb;
    var sharedOptions = {
      initialQuery: initialQuery,
      initialSelectionIds: initialSelectionIds,
      showHidden: showHidden,
      selectMultiple: selectMultiple !== null && selectMultiple !== void 0 ? selectMultiple : allowMultiple,
      actionVerb: actionVerb
    };
    var result = sharedOptions;

    if (this.props.resourceType === 'Product') {
      var _b = this.props,
          showVariants = _b.showVariants,
          showDraft = _b.showDraft,
          showArchived = _b.showArchived,
          showDraftBadge = _b.showDraftBadge,
          showArchivedBadge = _b.showArchivedBadge;
      var productSpecificOptions = {
        showVariants: showVariants,
        showDraft: showDraft,
        showArchived: showArchived,
        showDraftBadge: showDraftBadge,
        showArchivedBadge: showArchivedBadge
      };
      result = __assign(__assign({}, sharedOptions), productSpecificOptions);
    }

    return result;
  };

  ResourcePicker.contextType = context_1.AppBridgeContext;
  ResourcePicker.ActionVerb = actions_1.ResourcePicker.ActionVerb;
  return ResourcePicker;
}(react_1.default.PureComponent);

exports.default = ResourcePicker;